import { IntegrationsFlags } from "@brexhq/next/src/telemetry/types";

export const defaultEnabledCookiesItems: IntegrationsFlags = {
  "Amazon S3": true,
  "Google Tag Manager": true,
  snowflake: true,
  Amplitude: true,
  "Amplitude Actions": true,
  Hotjar: false,
  Mutiny: false,
  "Marketo V2": false,
  Statsig: true,
};
